import React from "react";

export const VolumeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M2.5 8.33333V11.6667H5.83333L9.16667 15V5L5.83333 8.33333H2.5Z" stroke="#002E19" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.0833 5.91667C15.3757 7.20911 16.1003 8.96015 16.1003 10.7833C16.1003 12.6065 15.3757 14.3576 14.0833 15.65" stroke="#002E19" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.775 8.225C12.4212 8.87121 12.7835 9.74673 12.7835 10.6583C12.7835 11.5699 12.4212 12.4455 11.775 13.0917" stroke="#002E19" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
